import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { CommonFunctionsService, UserService } from '../../../../_services/index';
import { Router } from '@angular/router';
import { CommonService, FooterService } from '../../service/index';
import { HttpClient } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import { JobseekerService } from 'src/app/modules/jobseeker/service/jobseeker.service';
import { ChatService } from '../../service/chat.service';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  providers: [
    CommonFunctionsService,
    UserService,
    CommonService,
    JobseekerService,
    FooterService,
  ],
})
export class FooterComponent implements OnInit {
  env = environment;
  footerData: any = {};
  JoinData: any = {};
  featuredCategory: any = [];
  isChatCardVisible = false;
  isLoadingMessages: boolean = false;
  currentMessage: string = '';
  messages: any = [];

  chatList: any[] = []; // List of chats
  selectedSessionId: string | null = null; // Store the selected session ID
  isChatSelected = false; // Track if a chat is selected
  @ViewChild('chatContainer', { static: false }) chatContainer!: ElementRef;
  
  constructor(
    public commonFunctionsService: CommonFunctionsService,
    public userService: UserService,
    public jobseekerService:JobseekerService,
    private commonService: CommonService,
    private footerService: FooterService,
    private renderer: Renderer2,
    private chatService: ChatService,
    public router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {

    this.chatService.toggleChatCard$.subscribe(() => {
      this.toggleChatCard();
    });
    console.log(this.userService.getCurrentUser().email, 'emaailllllllllllllllllllllllllllll')
    this.commonFunctionsService.isBrowser.subscribe((isBrowser) => {
      if (isBrowser) {
        this.getFooterBlockData();
        this.getStartedBlockData();
        this.featuredCategories();
        this.loadChatList(); // Load chat list on initialization
      }
    });
    // window.addEventListener('message', (event) => {
    //   if (event.data === 'toggleChatCard') {
    //     this.toggleChatCard();
    //   }
    // })
    // this.jobseekerService.toggleChatCard$.subscribe(() => {
 
    //   this.toggleChatCard();
    // });
  }

  // Listen for messages


// Define the function
//  toggleChatCard() {
//   // Your existing logic
//   this.isChatCardVisible = !this.isChatCardVisible;
//   this.loadChatList();
//   if (!this.isChatCardVisible) {
//       this.selectedSessionId = null;
//       this.isChatSelected = false;
//       this.messages = [];
//   }
// }


  toggleChatCard() {
   
    this.isChatCardVisible = !this.isChatCardVisible;
    this.loadChatList(); 
    if (!this.isChatCardVisible) {
      this.selectedSessionId = null;
      this.isChatSelected = false;
      this.messages=[]
    }
  }

  back() {
    this.loadChatList(); 
    this.selectedSessionId= "" ;
      this.isChatSelected = false;
      this.messages=[]
  }

  startConversation() {
    let uuid = uuidv4()
    this.selectedSessionId = uuid; 
    this.isChatSelected = true; 
  }



  sendMessage() {
    if (this.currentMessage.trim() === '') return;
    const payload = {
      data: {
        text: this.currentMessage,
        session_id: this.selectedSessionId,
        user_id: this.userService.getCurrentUser()._id
      },
      api_type: 'web',
      device_id: '',
      device_token: '',
      device_type: 'desktop'
    };
  

    this.messages.push({ text: this.currentMessage, type: 'incoming',  userid: this.userService.getCurrentUser()._id });
    this.scrollToBottom(); 
    this.currentMessage = '';
    this.footerService.sendChatMessage(payload).subscribe(
      (response: any) => {
        if (response.status === 'success' && Array.isArray(response.result)) {
          const currentUserId = this.userService.getCurrentUser()._id; // Get the current user ID
          response.result.forEach((message: any) => {
            this.messages.push({
              text: message.message, 
              type: message.userid === currentUserId ? 'incoming' : 'outgoing', // Set type based on 
              userid: message.userid  
            });
            this.scrollToBottom(); 
          });
    
        }
        else {
          this.messages.push({
            text: 'An error occurred or no messages returned. Please try again.',
            type: 'outgoing',
            userid: ""
          });
          this.scrollToBottom(); 
        }
      },
      (error: any) => {
        console.error('Error sending message', error);
        this.messages.push({
          text: 'An error occurred. Please try again.',
          type: 'outgoing',
          userid: ""
        });
        this.scrollToBottom(); 
      }
    );
  }
  
  public getFooterBlockData() {
    this.footerService.getFooterSetting().subscribe((response: any) => {
      if (response.status === this.env.SUCCESS_STATUS) {
        this.footerData = response.result;
      }
    });
  }

  public getStartedBlockData() {
    this.footerService.getStartedBlock().subscribe((response: any) => {
      if (response.status === this.env.SUCCESS_STATUS) {
        this.JoinData = response.result;
      }
    });
  }

  public featuredCategories() {
    // this.footerService.getFeaturedCategory().subscribe((response: any) => {
    //   if (response.status === this.env.SUCCESS_STATUS) {
    //     this.featuredCategory = response.result;
    //   }
    // });
    // Hide By Saju On Aug 29th 2024
  }

  public loadChatList() {
    const payload = {
      data: { user_id: this.userService.getCurrentUser()._id },
      api_type: 'web',
      device_id: '',
      device_token: '',
      device_type: 'desktop'
    };

    this.footerService.chatlist(payload).subscribe((response: any) => {
      if (response.status === 'success') {
        this.chatList = response.result;
      } else {
        console.error('Failed to load chat list');
      }
    }, (error: any) => {
      console.error('Error fetching chat list', error);
    });
  }

  public loadMessageList(sessionId: string): void {
    this.isLoadingMessages = true;
    this.selectedSessionId = sessionId; 
    this.isChatSelected = true;
    const payload = {
      data: { session_id: sessionId },
      api_type: 'web',
      device_id: '', 
      device_token: '', 
      device_type: 'desktop'
    };
    this.footerService.messagelist(payload).subscribe(
      (response: any) => {
        this.isLoadingMessages = false; 
        if (response.status === 'success' && response.result.length > 0) {
          this.messages = [];
          response.result.forEach((chat: any) => {
            this.messages = this.messages.concat(
              chat.messages.map((messagein: any) => ({
                text: messagein.message,  
                type: messagein.user_id ? 'incoming' : 'outgoing',
                userid: messagein.user_id  
              }))
            );
            this.scrollToBottom(); 
          });
          this.selectedSessionId = sessionId; 
          this.isChatSelected = true; 
        } else {
          console.error('Error: No messages found or unsuccessful response');
          this.messages = []; 
          this.isChatSelected = false; 
        }
      },
      (error: any) => {
        this.isLoadingMessages = false;
        console.error('Error fetching message list', error);
        this.messages = []; 
        this.isChatSelected = false; 
      }
    );
  }
  
  public checkProfileCompelete(): void {
    const userData = this.userService.getCurrentUser();
    if (userData.is_profile_complete) {
      this.router.navigate(['/jobs']);
    } else {
      this.router.navigate(['/jobseeker']);
    }
  }

  private scrollToBottom(): void {
    if (this.chatContainer && this.chatContainer.nativeElement) {
      this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
    }
  }
}
